module.exports = __webpack_public_path__ + "static/media/action.c90d08a3.svg";